/*
 * Copy paste for FabricJS.
 */


const copyPaste = (canvas, fabric) => {

  // copy
  document.addEventListener('copy', (e) => {
    if (!canvas.getActiveObject()) return

    // copy image as dataUrl
    if (canvas.getActiveObject().type === 'image') {
      e.preventDefault()

      e.clipboardData.setData('text/plain', canvas.getActiveObject().toDataURL())
    }


    // if selection is not an image, copy as JSON
    if (canvas.getActiveObject().type !== 'image') {
      e.preventDefault()
      canvas.getActiveObject().clone((cloned) => {
        e.clipboardData.setData('text/plain', JSON.stringify(cloned.toJSON()))
      })
    }
  })



  // JSON string validator
  const isJSONObjectString = (s) => {
    try {
      const o = JSON.parse(s);
      return !!o && (typeof o === 'object') && !Array.isArray(o)
    } catch {
      return false
    }
  }


  // base64 validator
  const isBase64String = (str) => {
    try {
      str = str.split('base64,').pop()
      window.atob(str)
      return true
    } catch (e) {
      return false
    }
  }

  let mousePos = { x: 0, y: 0 }

  // salva a posição do mouse no canvas
  canvas.on('mouse:move', (opt) => {
    const pointer = canvas.getPointer(opt.e)

    mousePos = {
      x: pointer.x,
      y: pointer.y
    }
  })


  //paste
  document.addEventListener('paste', (e) => {

    let pasteTextData = e.clipboardData.getData('text')

    // check if base64 image
    if (pasteTextData && isBase64String(pasteTextData)) {

      fabric.Image.fromURL(pasteTextData, (img) => {

        img.set({
          left: mousePos.x,
          top: mousePos.y,
          originX: 'center',
          originY: 'center'
        })

        img.scaleToHeight(300)
        img.scaleToWidth(300)

        canvas.add(img)
        canvas.setActiveObject(img)

        canvas.renderAll()
        canvas.trigger('object:modified')
      })

      return
    }

    // check if there's an image in clipboard items
    if (e.clipboardData.items.length > 0) {

      for (let i = 0; i < e.clipboardData.items.length; i++) {

        if (e.clipboardData.items[i].type.indexOf('image') === 0) {

          let blob = e.clipboardData.items[i].getAsFile()

          if (blob !== null) {

            let reader = new FileReader()

            reader.onload = (f) => {

              fabric.Image.fromURL(f.target.result, (img) => {

                img.set({
                  left: mousePos.x,
                  top: mousePos.y,
                  originX: 'center',
                  originY: 'center'
                })

                img.scaleToHeight(300)
                img.scaleToWidth(300)

                canvas.add(img)
                canvas.setActiveObject(img)

                canvas.renderAll()
                canvas.trigger('object:modified')
              })
            }

            reader.readAsDataURL(blob)
          }
        }
      }
    }
  })

}


export default copyPaste
